import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "as", "onlyFlex", "className", "type", "cols", "full"];
import styled from 'styled-components';
import { screens } from "../styles/breakpoints";
import { DASHBOARD_COLS, DESKTOP_COLS, getColsNum, MOBILE_COLS } from "./helpers";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-mfceuz-0"
})(["\n  /** flex fallback for older browsers */\n  display: flex;\n  flex-flow: wrap;\n  /** Mobile grid */\n  width: 100%;\n  ", "\n  margin-left: auto;\n  margin-right: auto;\n  /** Tablet grid */\n  ", " {\n    ", "\n  }\n  /** Desktop grid */\n  ", " {\n    padding-left: 0;\n    padding-right: 0;\n    max-width: ", ";\n  }\n"], function (_ref) {
  var full = _ref.full;
  return typeof full === 'boolean' && full || full && full.xs ? '' : "\n        padding-left: 4px;\n        padding-right: 4px;\n      ";
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up('sm');
}, function (_ref3) {
  var full = _ref3.full;
  return typeof full === 'boolean' && full || full && full.sm ? '' : "\n          padding-left: 12px;\n          padding-right: 12px;\n        ";
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up('md');
}, function (_ref5) {
  var full = _ref5.full;
  return typeof full === 'boolean' && full || full && full.md ? '100%' : '1240px';
});
var StyledGridContainer = /*#__PURE__*/styled(StyledContainer).withConfig({
  componentId: "sc-mfceuz-1"
})(["\n  @supports (display: grid) {\n    /** Mobile grid */\n    display: ", ";\n    display: ", ";\n    -ms-grid-columns: repeat(", ", 1fr);\n    grid-template-columns: repeat(", ", 1fr);\n    /** Tablet and Desktop grid */\n    ", "\n  }\n"], function (_ref6) {
  var cols = _ref6.cols;
  return getColsNum('xs', cols) > 0 ? '-ms-grid' : 'none';
}, function (_ref7) {
  var cols = _ref7.cols;
  return getColsNum('xs', cols) > 0 ? 'grid' : 'none';
}, function (_ref8) {
  var cols = _ref8.cols;
  return getColsNum('xs', cols);
}, function (_ref9) {
  var cols = _ref9.cols;
  return getColsNum('xs', cols);
}, function (_ref10) {
  var theme = _ref10.theme,
    cols = _ref10.cols;
  var responsiveStyles = '';
  Object.keys(screens).forEach(function (k, i) {
    var key = k;
    var colsNum = getColsNum(key, cols);
    if (colsNum >= 0 && (i === 0 ? colsNum !== getColsNum('xs', cols) : colsNum !== getColsNum(Object.keys(screens)[i - 1], cols))) {
      responsiveStyles = responsiveStyles.concat("\n            ".concat(theme.breakpoints.up(key), " {\n              display: ").concat(colsNum > 0 ? '-ms-grid' : 'none', ";\n              display: ").concat(colsNum > 0 ? 'grid' : 'none', ";\n              -ms-grid-columns: repeat(\n                ").concat(colsNum, ",\n                1fr\n              );\n              grid-template-columns: repeat(\n                ").concat(colsNum, ",\n                1fr\n              );\n            }\n          "));
    }
  });
  return responsiveStyles;
});
var Container = function Container(_ref11) {
  var children = _ref11.children,
    _ref11$as = _ref11.as,
    as = _ref11$as === void 0 ? 'div' : _ref11$as,
    onlyFlex = _ref11.onlyFlex,
    className = _ref11.className,
    _ref11$type = _ref11.type,
    type = _ref11$type === void 0 ? 'default' : _ref11$type,
    colsProp = _ref11.cols,
    fullProp = _ref11.full,
    other = _objectWithoutProperties(_ref11, _excluded);
  var cols = type === 'dashboard' ? DASHBOARD_COLS : {
    xs: MOBILE_COLS,
    sm: DESKTOP_COLS
  };
  var full = type === 'dashboard' ? true : fullProp;
  var props = _objectSpread({
    as: as,
    className: className,
    cols: colsProp || cols,
    full: full
  }, other);
  return onlyFlex ?
  /*#__PURE__*/
  // @ts-ignore
  _jsx(StyledContainer, _objectSpread(_objectSpread({}, props), {}, {
    children: children
  })) :
  /*#__PURE__*/
  // @ts-ignore
  _jsx(StyledGridContainer, _objectSpread(_objectSpread({}, props), {}, {
    children: children
  }));
};
export default Container;